import * as React from "react";
const DEFAULT_PIN = "1024";
function pinQuery(pin) {
  return `(min-width: ${pin}px)`;
}
const noop = () => {
};
function useMediaQuery(query) {
  const list = React.useMemo(
    () => typeof window !== "undefined" && typeof window.matchMedia === "function" ? window.matchMedia(query) : null,
    [query]
  );
  const subscribe = React.useCallback(
    (onChange) => {
      if (!list) return noop;
      if (typeof list.addEventListener === "function") {
        list.addEventListener("change", onChange);
        return () => list.removeEventListener("change", onChange);
      }
      list.addListener(onChange);
      return () => list.removeListener(onChange);
    },
    [list]
  );
  const getSnapshot = React.useCallback(() => list ? list.matches : false, [list]);
  return React.useSyncExternalStore(subscribe, getSnapshot, () => false);
}
function useControllableState(value, defaultValue, onChange) {
  const [inner, setInner] = React.useState(defaultValue);
  const controlled = value !== void 0;
  const onChangeRef = React.useRef(onChange);
  onChangeRef.current = onChange;
  const set = React.useCallback(
    (next) => {
      if (!controlled) setInner(next);
      onChangeRef.current?.(next);
    },
    [controlled]
  );
  return [controlled ? value : inner, set];
}
function useMountedRef() {
  const mounted = React.useRef(false);
  React.useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
    };
  }, []);
  return mounted;
}
export {
  DEFAULT_PIN,
  pinQuery,
  useControllableState,
  useMediaQuery,
  useMountedRef
};
//# sourceMappingURL=hooks.js.map
